import React, {Fragment} from "react"
import {Link} from "react-router-dom"


const handleSubmit =(e)=>{
    e.preventDefault();
}

const SignUp = () => {
    return (
        <Fragment>
            <form className="widget-form p-0" action="#" onSubmit={handleSubmit}>
                <div className="input-box mb-30">
                    <input type="text" placeholder="Usuario"/>
                </div>
                <div className="input-box mail mb-30">
                    <input type="email" placeholder="Correo Electrónico"/>
                </div>
                <div className="input-box phone mb-30">
                    <input type="text" placeholder="Número de Teléfono"/>
                </div>
                <div className="input-box pass mb-30">
                    <input type="text" placeholder="Contraseña"/>
                </div>
                <div className="input-box pass mb-30">
                    <input type="text" placeholder="Confirmar Contraseña"/>
                </div>
                <div className="input-check mb-30">
                    <input type="checkbox"/>
                    <span>Acepto los Términos y Condiciones</span>
                </div>
                <div className="col-12">
                    <button className="theme_btn">Enviar</button>
                    <span className="divider">O</span>
                    <button className="theme_btn signup-btn"><img className="mr-20" src="assets/img/icon/google.svg" alt="icon"/>
                        Registrarse con Google</button>
                    <p className="text-center mt-4">¿Ya tienes una cuenta? <Link to="/login">Iniciar Sesión</Link></p>
                </div>
            </form>
        </Fragment>
    )
}

export default SignUp